export default __webpack_public_path__ + "static/media/Age Rebut.9ed899c0.mp3";